import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import logo from '../../assets/images/logo/SS.png';

const green = {
  header: '#005487',
  light: '#e3e8eb',
  project: '#e3e8eb',
  total: '#e3e8eb',
};

export default function QuotationCreate() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // 🔐 Auto-generated / locked
  const quotationNo = 'auto genrate';
  const quotationDate = new Date().toLocaleString();

  // 📦 Customer (fetched from DB)
  //   const customer = {
  //     name: 'Rohit Sharma',
  //     email: 'rohitsharma@gmail.com',
  //     address: 'Off, Sarkhej - Gandhinagar Hwy, Makarba, Ahmedabad,Sarkhej-Okaf, Gujarat 382210',
  //     phone: '7845787852',
  //   };

  // 📊 Summary data
  const [summary, setSummary] = useState({
    modules: 18,
    moduleWp: 550,
    description: 'Total System Amt. + Structure (Mono Rail)',
    netPayable: 380000,
  });

  useEffect(() => {
    setSummary((prev) => ({
      ...prev,
      modules: Math.ceil((state.requirementCapacity * 1000) / 550),
    }));
  }, [state]);

  // 📝 Notes (static or config-based)
  const notes = [
    'Solar Panel: 25 Years Generation Warranty.',
    'Inverter: 10 Years Warranty.',
    'Maintenance: Free up to 5 Years.',
    'Net-metering fee to be paid separately by the customer.',
    'Final quotation received while finalizing the order will be accepted.',
  ];

  // 🧾 BOM
  const [bomItems, setBomItems] = useState([
    // {
    //   id: 1,
    //   name: 'Solar PV Module',
    //   spec: '550wp Topcon',
    //   make: 'Sunbond',
    //   qty: 18,
    // },
    // {
    //   id: 2,
    //   name: 'Solar On-Grid Inverter',
    //   spec: 'IP65 protection',
    //   make: 'Shree Solar',
    //   qty: 1,
    // },
  ]);
  const [data, setData] = useState([]);

  const updateQty = (id, qty) => {
    setBomItems((prev) => prev.map((item) => (item.id === id ? { ...item, qty } : item)));
  };

  // 🚀 Submit
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        quotationNo,
        quotationDate,
        customerId: 'customer_id_here',
        summary,
        bomItems,
      };

      const res = await post(`users/create_quotation/${state._id}`, { ...payload });
      if (res.status == 200) {
        enqueueSnackbar(res.message || 'Quotation Create Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        navigate('/enquiry');
      } else {
        enqueueSnackbar(res.message || 'Error while creating quotation', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while creating quotation', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchProduct = async () => {
    try {
      const res = await post('users/dropdown_product', {});
      if (res.status == 200) {
        setData(res.data);
      } else {
        enqueueSnackbar(res.message || 'Error while Fetching Product', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Fetching Product', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);
  return (
    <Container maxWidth="lg">
      <Box sx={{ background: '#fff', p: 4 }}>
        <HeaderSection quotationNo={quotationNo} date={quotationDate} />

        <AddressSection customer={state} />

        <SummaryTable data={summary} setData={setSummary} />

        <NotesSection notes={notes} />

        <Divider sx={{ my: 4 }} />

        <TextField
          select
          label="Select Item"
          value={bomItems?._id || ''}
          onChange={(e) => {
            const item = data.find((i) => i._id === e.target.value);
            setBomItems((prev) => [...prev, item]);
          }}
          sx={{ width: 300, mb: 2 }}
        >
          <MenuItem value="">Select...</MenuItem>
          {data.map((item) => (
            <MenuItem key={item._id} value={item._id}>
              {item.productName}
            </MenuItem>
          ))}
        </TextField>

        <BOMSection items={bomItems} setItems={setBomItems} updateQty={updateQty} />

        <FooterSection />

        {/* ACTIONS */}
        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          {/* <Button variant="outlined">Preview PDF</Button> */}
          <Button variant="contained" onClick={handleSubmit} loading={loading}>
            Save Quotation
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

const HeaderSection = ({ quotationNo, date }) => (
  <Box display="flex" justifyContent="space-between" mb={2}>
    <Box>
      <img src={logo} alt="logo" width={140} />
    </Box>

    <Box textAlign="left">
      <Typography fontSize={13}>
        <b>Quotation No</b> : {quotationNo}
      </Typography>
      <Typography fontSize={13}>
        <b>Quotation Date</b> : {date}
      </Typography>
    </Box>
  </Box>
);

const AddressBox = ({ title, children }) => (
  <Paper sx={{ p: 2, background: green.light, borderRadius: 2, height: '100%' }}>
    <Typography color={green.header} fontWeight={600} mb={1}>
      {title}
    </Typography>
    {children}
  </Paper>
);

const AddressSection = ({ customer }) => (
  <Grid container spacing={2} mb={3} sx={{ width: '100%' }}>
    <Grid item size={{ xs: 6 }}>
      <AddressBox title="From">
        <Typography fontWeight={700}>Shree Solar Sunstar</Typography>
        <Typography>Titanium Business Park, A/213, Makarba</Typography>
        <Typography>Ahmedabad</Typography>
        <Typography>Gujarat India - 380051</Typography>
        <Typography>
          <strong>Email</strong>: admin@shreesolarsunstar.com
        </Typography>
        <Typography>
          <strong> Phone</strong>: +91 87507-78800
        </Typography>
      </AddressBox>
    </Grid>

    <Grid item size={{ xs: 6 }}>
      <AddressBox title="To">
        <Typography fontWeight={700}>{customer.name}</Typography>
        <Typography>{customer.address}</Typography>
        <Typography>
          <strong>Email</strong>: {customer?.email || 'N/A'}
        </Typography>
        <Typography>
          <strong>Phone</strong>: {customer.mobile}
        </Typography>
      </AddressBox>
    </Grid>
  </Grid>
);

const CellInput = (props) => (
  <TextField variant="standard" InputProps={{ disableUnderline: true }} fullWidth {...props} />
);

const SummaryTable = ({ data, setData }) => (
  <Table sx={{ mb: 3 }}>
    <TableHead>
      <TableRow sx={{ background: green.header }}>
        {['Module (Nos.)', 'Module Wp', 'System Cap. (kw)', 'Description', 'Net Payable'].map(
          (h) => (
            <TableCell
              key={h}
              sx={{
                backgroundColor: green.header + ' !important',
                color: '#fff !important',
                fontWeight: 600,
              }}
            >
              {h}
            </TableCell>
          ),
        )}
      </TableRow>
    </TableHead>

    <TableBody>
      <TableRow>
        <TableCell>
          <CellInput
            type="number"
            value={data.modules}
            onChange={(e) => setData({ ...data, modules: e.target.value })}
          />
        </TableCell>

        <TableCell>
          <CellInput
            type="number"
            value={data.moduleWp}
            onChange={(e) => setData({ ...data, moduleWp: e.target.value })}
          />
        </TableCell>

        <TableCell>{((data.modules * data.moduleWp) / 1000).toFixed(2)}</TableCell>

        <TableCell>
          <CellInput
            value={data.description}
            onChange={(e) => setData({ ...data, description: e.target.value })}
          />
        </TableCell>

        <TableCell align="right">
          <CellInput
            type="number"
            value={data.netPayable}
            onChange={(e) => setData({ ...data, netPayable: e.target.value })}
          />
        </TableCell>
      </TableRow>

      <TableRow sx={{ background: green.project }}>
        <TableCell colSpan={4}>
          <b>Project Cost</b>
        </TableCell>
        <TableCell align="right">
          <b>₹ {data.netPayable}</b>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);

const NotesSection = ({ notes }) => (
  <Box mb={3}>
    <Typography fontWeight={600}>Note:</Typography>
    <List dense>
      {notes.map((n, i) => (
        <ListItem key={i}>
          <ListItemText primary={n} />
        </ListItem>
      ))}
    </List>
  </Box>
);

const BOMSection = ({ items, setItems }) => (
  <Table>
    <TableHead>
      <TableRow sx={{ background: green.header }}>
        {['No', 'Item', 'Spec', 'Make'].map((h) => (
          <TableCell key={h} sx={{ color: '#fff', backgroundColor: green.header + ' !important' }}>
            {h}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

    <TableBody>
      {items.map((item, i) => (
        <TableRow key={item._id} sx={{ background: i % 2 ? green.light : 'inherit' }}>
          <TableCell>{i + 1}</TableCell>
          <TableCell>{item.type.name}</TableCell>
          <TableCell>
            <CellInput
              value={item.productName}
              onChange={(e) => {
                const value = e.target.value;
                setItems((prev) =>
                  prev.map((row, index) => (index === i ? { ...row, productName: value } : row)),
                );
              }}
            />
          </TableCell>
          <TableCell>{item.manufactureName}</TableCell>

          {/* <TableCell>
            <CellInput
              type="number"
              value={item.qty}
              onChange={(e) => updateQty(item.id, e.target.value)}
            />
          </TableCell> */}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

const FooterSection = () => (
  <Box mt={4}>
    <Typography fontWeight={600} color={green.header}>
      Documents Required
    </Typography>

    <Grid container spacing={1} mb={3}>
      {[
        'Passport Photos',
        'Light Bill Xerox',
        'Tax Bill Xerox',
        'Aadhaar Card Xerox',
        'PAN Card Xerox',
        'Cancelled Cheque',
      ].map((d, i) => (
        <Grid item xs={6} key={i}>
          ({i + 1}) {d}
        </Grid>
      ))}
    </Grid>

    <Paper sx={{ p: 2, background: green.light, textAlign: 'center' }}>
      <Typography fontWeight={700} color={green.header}>
        Thank You for Choosing a Greener Future!
      </Typography>
      <Typography fontSize={12}>
        We are committed to delivering the best solar solutions.
      </Typography>
    </Paper>
  </Box>
);
